import React from 'react';
import { connect, useSelector } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, ReviewOverviewCarouselProps } from 'component/page/detail/Review/Review.selectors';
import { Box, HorizontalScroll } from '@drone-js/core';
import ReviewCard from 'component/page/detail/Review/ReviewCard/ReviewCard';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

const ReviewOverviewCarousel: React.FC<ReviewOverviewCarouselProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    if (!props.reviewList || props.reviewList.length === 0) {
        return null;
    }

    return (
        <HorizontalScroll data-testid="activities-review-overview-carousel" mb="4" p="2" gap="12" nextLabel={cms[130706]} previousLabel={cms[130765]}>
            {props.reviewList.map((review, index) => {
                return (
                    <Box as="button" key={review.id} textAlign="left" p="0" borderRadius="16">
                        <ReviewCard index={index} review={review} minimal={true} isInOverlay={false} />
                    </Box>
                );
            })}
        </HorizontalScroll>
    );
};

ReviewOverviewCarousel.displayName = 'ReviewOverviewCarousel';
export default connect(mapStateToProps, mapDispatchToProps)(ReviewOverviewCarousel);
